export function hasUserPermission(userPermissions, requiredPermission) {
  if (!requiredPermission) return true;

  const names = Array.isArray(requiredPermission) ? requiredPermission : [requiredPermission];

  return names.some((name) => userPermissions?.[name]);
}
